//Componentes generales
import React, { useState } from "react";

// Iconos
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBox, faRotate } from "@fortawesome/free-solid-svg-icons";

const ProductRow = ({ producto, actualizarProductDBIndividual }) => {
  const [loading, setLoading] = useState(false);
  const [feedback, setFeedback] = useState(null); // null | 'ok' | 'error'

  const formatter = new Intl.NumberFormat("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  const priceString = formatter.format(producto.price ? producto.price : 0);

  const handleActualizar = async () => {
    if (!actualizarProductDBIndividual || loading) return;
    setLoading(true);
    setFeedback(null);
    const resp = await actualizarProductDBIndividual(producto.tipPro, producto.artCod);
    setLoading(false);
    setFeedback(resp.status ? "ok" : "error");
    setTimeout(() => setFeedback(null), 2500);
  };

  const fieldStyle = {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: "5px",
    padding: "0 44px 0 0",
    whiteSpace: "nowrap",
    fontSize: "1rem",
    fontWeight: "600",
    color: "black",
  };
  const valueStyle = {
    fontWeight: "400",
    color: "rgb(108, 108, 108)",
  };
  const emptyStyle = { ...valueStyle, fontSize: "2.2rem", lineHeight: 1 };

  return (
    <div className="container-p-list-item">
      {/* Fila 1: icono + campos + botón */}
      <div style={{ display: "flex", alignItems: "center", padding: "8px 0 4px 0" }}>
        <div className="list-item-icon-p">
          <FontAwesomeIcon icon={faBox} />
        </div>
        <span style={fieldStyle}>Tipo: <span style={producto.tipPro ? valueStyle : emptyStyle}>{producto.tipPro || "-"}</span></span>
        <span style={fieldStyle}>Código Art.: <span style={producto.artCod ? valueStyle : emptyStyle}>{producto.artCod || "-"}</span></span>
        <span style={fieldStyle}>Cód. Reducido: <span style={producto.codRed ? valueStyle : emptyStyle}>{producto.codRed || "-"}</span></span>
        <span style={fieldStyle}>Unidad: <span style={producto.uniMed ? valueStyle : emptyStyle}>{producto.uniMed || "-"}</span></span>
        <span style={fieldStyle}>Cuenta para compras: <span style={producto.cuenPv ? valueStyle : emptyStyle}>{producto.cuenPv || "-"}</span></span>
        <span style={fieldStyle}>Último precio: <span style={valueStyle}>USD {priceString}</span></span>
        {actualizarProductDBIndividual && (
          <button
            onClick={handleActualizar}
            disabled={loading}
            title="Actualizar este producto desde Softland"
            style={{
              marginLeft: "8px",
              padding: "5px 12px",
              fontSize: "0.85rem",
              fontWeight: "600",
              cursor: loading ? "not-allowed" : "pointer",
              border: "none",
              borderRadius: "5px",
              backgroundColor: feedback === "ok" ? "#28a745" : feedback === "error" ? "#dc3545" : "#495057",
              color: "#ffffff",
              display: "flex",
              alignItems: "center",
              gap: "6px",
              whiteSpace: "nowrap",
              opacity: loading ? 0.75 : 1,
              boxShadow: "0 1px 4px rgba(0,0,0,0.25)",
            }}
          >
            <FontAwesomeIcon icon={faRotate} spin={loading} />
            {feedback === "ok" ? "Actualizado" : feedback === "error" ? "Error" : "Actualizar"}
          </button>
        )}
      </div>
      {/* Fila 2: descripción */}
      <div style={{ display: "flex", alignItems: "center", paddingLeft: "110px", paddingBottom: "6px" }}>
        <span style={fieldStyle}>Descripción: <span style={producto.descrp ? valueStyle : emptyStyle}>{producto.descrp || "-"}</span></span>
      </div>
    </div>
  );
};

const RenderRow = ({ index, style, productos = [], filter, actualizarProductDBIndividual }) => {
  const lista = filter === ""
    ? productos
    : productos.filter(
        (p) =>
          p.descrp.toLowerCase().includes(filter.toLowerCase()) ||
          p.tipPro.toLowerCase().includes(filter.toLowerCase()) ||
          p.artCod.toLowerCase().includes(filter.toLowerCase()) ||
          p.codRed.toLowerCase().includes(filter.toLowerCase())
      );

  const producto = lista[index];
  if (!producto) return null;

  return (
    <div style={style} className="container-p-list">
      <li>
        <ProductRow
          producto={producto}
          actualizarProductDBIndividual={actualizarProductDBIndividual}
        />
      </li>
    </div>
  );
};

export default RenderRow;
